import React, { Component } from "react";
import { connect } from "react-redux";
import { pick } from "lodash";

// Components
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";
import ErrorWrap from "../error-success/ErrorWrap";
import SuccessWrap from "../error-success/SuccessWrap";
import ImageUploaderSimple from "../ImageUploaderSimple";

// Utils
import icon from "../../../utils/icons/user.js";
import { deleteTempImages } from "../../../utils/uploadHelpers";

// State
import { updateReviewerImage } from "../../../store/actions/reviewers";

class ReviewerProfileImageUploadDialog extends Component {
	constructor(props) {
		super(props);

		this.state = {
			imageUpdated: false,
			uploadStarted: false, // We need to notify the promise within ImageUploaderSimple to start
			promiseCollection: []
		};
	}

	handleImgUpdate = () => {
		this.setState({
			imageUpdated: true
		});
	};

	// ===================================================================================
	//  SUBMIT
	// ===================================================================================
	handleSubmit = () => {
		this.setState(
			{
				uploadStarted: true
			},
			() => {
				Promise.all(this.state.promiseCollection)
					.then(resolves => {
						this.setState({
							promiseCollection: [],
							uploadStarted: false
						});

						this.completeSubmit(resolves);
					})
					.catch(err => {
						// console.log("err parent:", err);
						this.setState({
							promiseCollection: [],
							uploadStarted: false
						});
					});
			}
		);
	};

	completeSubmit = resolves => {
		// Get chunked image results for file.
		// Either array of objects, or null
		const pic = resolves[0]
			? resolves.filter(obj => {
					if (!obj) return false;
					return obj[0].type === "pic";
			  })[0]
			: null;

		// Put request data together
		const data = {
			image: !!pic ? pick(pic[0].results, ["dirName", "filename"]) : ""
		};

		// We might need to delete these later
		const uploadedUrls = [];
		if (!!pic) uploadedUrls.push(data.image);

		// console.log(uploadedUrls);

		this.props
			.updateReviewerImage(data)
			.then(response => {
				// console.log("success", uploadedUrls);

				if (!response) {
					deleteTempImages(uploadedUrls, this.props.loggedInReviewer.token).catch(err => {
						console.log(err);
					});

					return;
				}

				this.setState({
					imageUpdated: false
				});
			})
			.catch(err => {
				// console.error("error", err);

				deleteTempImages(uploadedUrls, this.props.loggedInReviewer.token).catch(err => {
					console.log(err);
				});
			});
	};

	render() {
		const {
			translations,
			user,
			reviewerImageUploadInProgress,
			reviewerImageUploadErrors,
			reviewerImageUploadSuccess
		} = this.props;
		const { imageUpdated, uploadStarted } = this.state;

		const buttons = [
			{
				type: Button,
				text: translations.sections.buttons.close,
				action: () => this.props.handleClose(),
				disabled: reviewerImageUploadInProgress
			},
			{
				type: Button,
				text: translations.sections.reviewer_form.upload_button,
				action: () => this.handleSubmit(),
				disabled: reviewerImageUploadInProgress || !imageUpdated
			}
		];

		return this.props.show ? (
			<Modal
				title={translations.sections.reviewer_form.profile_image_dialog_title}
				buttons={buttons}
			>
				<div className="image-flex-wrapper">
					<div className="profile-pic">
						<ImageUploaderSimple
							placeholder={icon}
							initialImages={user.pic ? [user.pic] : []}
							required={false}
							type={"pic"}
							uploadAssetType={"reviewer"}
							handleExistingImageRemoval={this.handleImgUpdate}
							addPromise={promise => {
								this.state.promiseCollection.push(promise);
							}}
							loading={uploadStarted}
							clear={this.props.clearImageUploader}
							handleParentImgUpdate={this.handleImgUpdate}
							isNonce={true}
							token={this.props.loggedInReviewer.token}
						/>
					</div>
					<div className="image-flex-wrapper--text">
						<div className="image-flex-wrapper--instructions">
							{translations.sections.reviewer_form.profile_image_dialog_direction}
						</div>
						{!!reviewerImageUploadSuccess && (
							<SuccessWrap animate={1}>{reviewerImageUploadSuccess}</SuccessWrap>
						)}
						{!!reviewerImageUploadErrors && (
							<ErrorWrap animate={1}>{reviewerImageUploadErrors}</ErrorWrap>
						)}
					</div>
				</div>
			</Modal>
		) : null;
	}
}

const mapStateToProps = state => {
	return {
		loggedInReviewer: state.user.reviewer,
		reviewerImageUploadInProgress: state.reviewers.reviewerImageUploadInProgress,
		reviewerImageUploadErrors: state.reviewers.reviewerImageUploadErrors,
		reviewerImageUploadSuccess: state.reviewers.reviewerImageUploadSuccess
	};
};

export default connect(
	mapStateToProps,
	{ updateReviewerImage }
)(ReviewerProfileImageUploadDialog);



// WEBPACK FOOTER //
// ./src/components/utils/dialogs/ReviewerProfileImageUploadDialog.js